// project = "TO" AND created >= "-28d" ORDER BY created DESC

import { createResource } from '@atlassian/react-resource-router';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-knowledge-base-fetch-project-issues", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-fetch-project-issues" */ './get-data'
	);

export const servicedeskKnowledgeBaseFetchProjectIssuesResource = createResource({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_FETCH_PROJECT_ISSUES',
	getKey: ({ match }) => match.query.projectKey || '',
	getDataLoader,
});
